import { environment } from '../../../environments/environment';

export enum PartnerName {
  Connext = 'connext',
  Myneva = 'myneva',
  Medifox = 'medifox',
}

export interface PartnerDefinition {
  id: number;
  name: PartnerName;
  displayName: string;
  copyName: string;
  copyShortName: string;
  icon: string;
  logo: string;
  syncsToShop: boolean;
  acceptsPartnerToken: boolean;
  issuesShopToken: boolean;
  requiresPartnerAccountForBilling: boolean;
}

export const PARTNERS: PartnerDefinition[] = [
  {
    id: environment.connextPartnerId,
    name: PartnerName.Connext,
    displayName: 'Connext Vivendi',
    copyName: 'Connext Vivendi',
    copyShortName: 'Vivendi',
    icon: '/assets/icons/connextVivendi-icon.svg',
    logo: '/assets/img/connext-logo.png',
    syncsToShop: true,
    acceptsPartnerToken: true,
    issuesShopToken: false,
    requiresPartnerAccountForBilling: true,
  },
  {
    id: environment.mynevaPartnerId,
    name: PartnerName.Myneva,
    displayName: 'myneva',
    copyName: 'myneva',
    copyShortName: 'myneva',
    icon: '/assets/icons/myneva-icon.svg',
    logo: '/assets/img/myneva.png',
    syncsToShop: false,
    acceptsPartnerToken: false,
    issuesShopToken: true,
    requiresPartnerAccountForBilling: true,
  },
  {
    id: environment.medifoxPartnerId,
    name: PartnerName.Medifox,
    displayName: 'MEDIFOX DAN',
    copyName: 'MediFox',
    copyShortName: 'MediFox',
    icon: '/assets/icons/medifox-icon.webp',
    logo: '/assets/img/medifox-logo.webp',
    syncsToShop: true,
    acceptsPartnerToken: true,
    issuesShopToken: false,
    requiresPartnerAccountForBilling: false,
  },
];

export const getPartner = (
  partnerId?: number | null
): PartnerDefinition | undefined =>
  partnerId ? PARTNERS.find(partner => partner.id === partnerId) : undefined;

export const getPartnerName = (
  partnerId?: number | null
): PartnerName | undefined => getPartner(partnerId)?.name;

export const syncsToShop = (partnerId?: number | null): boolean =>
  getPartner(partnerId)?.syncsToShop ?? false;

export const issuesShopToken = (partnerId?: number | null): boolean =>
  getPartner(partnerId)?.issuesShopToken ?? false;

export const requiresPartnerAccountForBilling = (
  partnerId?: number | null
): boolean => getPartner(partnerId)?.requiresPartnerAccountForBilling ?? true;

export type PartnerCopyNameForm = 'full' | 'short';

export const getPartnerCopyName = (
  partnerId?: number | null,
  form: PartnerCopyNameForm = 'full'
): string => {
  const partner =
    getPartner(partnerId) ??
    PARTNERS.find(({ name }) => name === PartnerName.Connext);
  return form === 'short' ? partner.copyShortName : partner.copyName;
};
